import React from 'react'
import './styles.scss'

export const QuarantineBatch = ({
  hasQuarantine,
  start,
  end,
  LOCALES
}: {
  start?: string
  end?: string
  hasQuarantine: boolean
  LOCALES: {
    basic: string
    hasStarted: string
    willStart: string
    willEnd: string
    noQuarantine: string
    localeFormat: string
  }
}) => {
  const formatDate = (a: string) =>
    new Date(a).toLocaleDateString(LOCALES.localeFormat, {
      month: 'numeric',
      day: 'numeric',
    })

  const _from = start ? formatDate(start) : ''
  const _to = end ? formatDate(end) : ''

  let text = hasQuarantine ? LOCALES.basic : LOCALES.noQuarantine
  if (end) text = LOCALES.willEnd + ' ' + _to
  if (start)
    text =
      new Date(start) < new Date()
        ? LOCALES.hasStarted + ' ' + _from
        : LOCALES.willStart + ' ' + _from

  return (
    <div className={'QuarantineBatch ' + (hasQuarantine ? 'q' : '')}>
      {text}
    </div>
  )
}
